<template>
    <div>
        <form autocomplete="off" @submit.prevent="postBajasSuspenciones()">
            <vs-row class="p-4">
                <vs-col w="12" class="lineTitulo mb-2">
                    <h5><strong>BAJAS Y SUSPENSIONES</strong></h5>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Estatus</label>
                    <vs-select
                        filter
                        class="pt-0"
                        placeholder="Estatus" 
                        v-model="estatu"
                        :key="estatuId" 
                    >
                        <vs-option v-for="(statu, i) in estatus" :key="i" :label="statu.status" :value="statu.id">
                            {{statu.status}}
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('estatu')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label class="pl-0">Comentario</label>
                    <div>
                        <textarea v-model="comentario" rows="2" cols="50"></textarea>
                    </div>
                </vs-col>
                <vs-col w="12" class="mt-2 d-flex">
                    <vs-button
                        success
                        type="submit"
                        class="ml-auto"
                    >
                        Guardar
                    </vs-button>
                </vs-col>
                <vs-col>
                    <vs-table striped>
                        <template #thead>
                        <vs-tr>
                            <vs-th style="width: 25%">
                                Usuario
                            </vs-th>
                            <vs-th style="width: 25%">
                                Fecha
                            </vs-th>
                            <vs-th style="width: 25%">
                                Estatus
                            </vs-th>
                            <vs-th style="width: 25%">
                                Comentario
                            </vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody>
                        <vs-tr
                            :key="i"
                            v-for="(tr, i) in statusGuardados"
                            :data="tr"
                        >
                            <vs-td>
                                {{ tr.user }}
                            </vs-td>
                            <vs-td>
                                {{ tr.date }}
                            </vs-td>
                            <vs-td>
                                {{ tr.status }}
                            </vs-td>
                            <vs-td>
                                {{ tr.comment }}
                            </vs-td>
                        </vs-tr>
                        </template>
                    </vs-table>
                </vs-col>
            </vs-row>
        </form>
    </div>
</template>
<script>
import alumnos from '../../../../api/requests/alumno'
export default {
    props: [
        'general',
        'personaRol',
        'institucion_id_url',
        'proceso',
    ],
    data(){
        return{
            estatu:'',
            estatus: [],
            estatuId: (new Date()).getTime(),
            comentario: '',
            statusGuardados: [],
            errorFields: []
        }
    },
    methods: {
        async getEstatusBajasSuspenciones(){
            if(this.general.datos.persona_id){
                try{
                    const params = {
                        institucion_id: this.institucion_id_url
                    }
                    const { data: response } = await alumnos.getEstatusBajasSuspenciones(this.general.datos.persona_id, params)
                    this.statusGuardados = response
                }catch{

                }
            }
        },
        async getEstatusAlumno(){
            try{
                const params = {
                    type: 'baja'
                }
                const {data: response} = await alumnos.getEstatusAlumno(params)
                this.estatus = response
                const reactivacion = {
                    "id": 16,
                    "status": "Reactivación",
                }
                this.estatus.push(reactivacion);
                this.estatuId = (new Date()).getTime()
            }catch(error){
                console.error(error)
            }
        },
        async postBajasSuspenciones(){
            if(!this.estatu){
                this.errorFields.push('estatu')
            }
            else{
                this.errorFields = []
                const loading = this.$vs.loading()
                try{
                    const formaData = new FormData();
                    formaData.append('_method', 'PATCH')
                    formaData.append('estatus', this.estatu)
                    formaData.append('comentario', this.comentario)
                    formaData.append('institicion_id', this.institucion_id_url)
                    const {data: response} = await alumnos.postBajasSuspenciones(this.general.datos.persona_id, formaData)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        icon: '<i class="fas fa-check"></i>',
                        title: 'Operación éxitosa',
                        text: response.message
                    })
                    loading.close()
                    this.estatu = ''
                    this.comentario = ''
                    this.getEstatusBajasSuspenciones()
                    this.$emit('refreshComponent', this.general.datos.persona_id, this.proceso)
                }catch{
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Operación éxitosa',
                        text: response.message
                    })
                }
            }
        },
    },
    watch:{
        general(){
            this.getEstatusAlumno()
            this.getEstatusBajasSuspenciones()
        },
    }
}
</script>
<style>
.lineTitulo{
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
.inputTitulo label{
    padding-left: 11px;
    margin-top: 2%;
}
</style>
